import getCSSVarMap from './helpers/getCSSVarMap';
import WebFonts from './helpers/WebFonts';
import withStyledSystem from './helpers/withStyledSystem';
import theme from './theme';

export default theme;
export * from './helpers/withStyledSystem';
export * from './theme';
export { getCSSVarMap, WebFonts, withStyledSystem };
